import { render, staticRenderFns } from "./AnimatedFrame.vue?vue&type=template&id=0ca43e52&scoped=true&"
import script from "./AnimatedFrame.vue?vue&type=script&lang=js&"
export * from "./AnimatedFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca43e52",
  null
  
)

export default component.exports